__turbopack_context__.v({
  "circle": "messageIcon-module-scss-module__p2os9G__circle",
  "circle__number": "messageIcon-module-scss-module__p2os9G__circle__number",
  "icon": "messageIcon-module-scss-module__p2os9G__icon",
  "messageIconButton": "messageIcon-module-scss-module__p2os9G__messageIconButton",
});
